export default {
    name: 'userservice',
    dependencies: ['radio', 'xhrservice', 'objectstore'],
    callable(radio, xhr, objectstore) {
        let personalContentPromise;
        let _loggedInPromise;
        let _promisePending = true;

        const PERSONAL_CONTENT_KEY = 'personal_content';
        const VISITED_AD_KEY = 'visited_ads';
        const EXCLUDED_AD_KEY = 'excluded_ads';
        const REVALIDATE_KEY = 'must-revalidate-login';
        const DATA_READY = 'personal-content-ready';

        init();

        function init() {
            _loggedInPromise = _getLoginStatePromise();
            personalContentPromise = _getPCPromiseAndBroadcastDone();
        }

        function _getPCPromiseAndBroadcastDone() {
            _promisePending = true;
            function emitEventAndClose(e) {
                _promisePending = false;
                radio(DATA_READY).broadcast();
                return e;
            }

            return _loggedInPromise.then(isLoggedIn =>
                _getPersonalContentPromise(isLoggedIn).then(emitEventAndClose)
            );
        }

        function forceRefresh() {
            objectstore.del(PERSONAL_CONTENT_KEY);
            if (!_promisePending) {
                personalContentPromise = _getPCPromiseAndBroadcastDone();
            }
            return personalContentPromise;
        }

        function _mustRevalidate() {
            let result = false;
            try {
                result = !!window.localStorage.getItem(REVALIDATE_KEY);
                window.localStorage.removeItem(REVALIDATE_KEY);
            } catch (e) {}
            return result;
        }

        function _getLoginStatePromise() {
            let promise;
            if (_mustRevalidate()) {
                promise = _fetchPersonalContentData();
            } else {
                promise = _getPersonalContentPromise(_hasUserIdTag());
            }
            return promise.then(e => e.loggedIn);
        }

        function _getPersonalContentPromise(isLoggedIn) {
            if (isLoggedIn) {
                const data = objectstore.get(PERSONAL_CONTENT_KEY);
                if (data) {
                    return Promise.resolve(data);
                }
                return _fetchPersonalContentData();
            }
            return Promise.resolve({ loggedIn: false });
        }

        function _fetchPersonalContentData() {
            return new Promise(resolve => {
                function successHandler(response) {
                    response.loggedIn = true;
                    // Finnbox needs short cache time to make 'unread counter'
                    // appear/update as soon as possible when there are new messages.
                    objectstore.put(PERSONAL_CONTENT_KEY, response, 3 * 60);
                    resolve(response);
                }

                function errorHandler(error) {
                    if (error && error.status === 401) {
                        // not being logged in isn't an error.
                        resolve({ loggedIn: false });
                    } else {
                        resolve({ loggedIn: false });
                        if (console && console.log) {
                            console.log(
                                'unknown xhr error',
                                error,
                                error.stack
                            );
                        }
                        throw error;
                    }
                }

                xhr
                    .getJson('/user/personalcontent.json')
                    .then(successHandler, errorHandler);
            });
        }

        function _hasUserIdTag() {
            return !!document.querySelector("meta[name='FINN.userid']");
        }

        function getAccountDataPromise() {
            return personalContentPromise;
        }

        function addExcludedAdIds(adIds) {
            objectstore.put(EXCLUDED_AD_KEY, adIds);
        }

        function getVisitedAdIds() {
            return objectstore.get(VISITED_AD_KEY) || [];
        }

        function getExcludedAdIds() {
            return objectstore.get(EXCLUDED_AD_KEY) || [];
        }

        return {
            getAccountData: getAccountDataPromise,
            forceRefresh,
            getVisitedAdIds,
            addExcludedAdIds,
            getExcludedAdIds,
            DATA_READY,
        };
    },
};



// WEBPACK FOOTER //
// ./services/userservice.js